export default __webpack_public_path__ + "95d91664f24cf674c266245fae0505a7.svg";